import type { CookieOptions } from '#app';
import { useIframeAuthFlow } from '~/composables/useIframeAuthFlow';

export function useAuthCookie<T = string | null>(name: string, extraOptions?: Omit<CookieOptions<T>, 'readonly'>) {
    const { cookieOptions } = useIframeAuthFlow();

    return useCookie<T>(name, {
        ...cookieOptions.value,
        ...extraOptions
    });
}
